import React from 'react'
import Layout from '../../components/common/pageLayout'
import CreateForm from '../../components/FinalDrawing/createForm'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { toast } from 'react-toastify'
import { v3_create_drawing } from '../../actions/v3/drawing'

const Index = (props) => {
    const location = useLocation();
    const { projectId, projectName } = location.state || {};

    const onSubmit = (model) => {
        v3_create_drawing(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)

                props.history.push({
                    pathname: constant.Authedcomponent.finalDrawingDetail.url,
                    state: {
                        projectId,
                        projectName
                    }
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }

    return (
        <Layout title={`New Drawing | ${projectName}`}>
            <CreateForm
                projectName={projectName}
                onSubmit={onSubmit}
                projectId={projectId}
            />
        </Layout>
    )
}

export default Index
